var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('super-container-view',[_c('brand-info-resource-list',{attrs:{"brandInfos":_vm.brand_infos,"actions":{ fetchResource: _vm.fetchResource }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }